var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('carousel-3d',{attrs:{"id":"gallery-3d","autoplay":true,"width":450,"height":650,"display":5}},_vm._l((_vm.gallerySlides),function(slide,i){return _c('slide',{key:i,attrs:{"index":i},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var index = ref.index;
var isCurrent = ref.isCurrent;
var leftIndex = ref.leftIndex;
var rightIndex = ref.rightIndex;
return [_c('img',{class:{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) },attrs:{"data-index":index,"src":slide.image}})]}}],null,true)})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }